module.exports = __webpack_public_path__ + "img/wall-street.85f722ea.jpg";